import { useState } from "react";
import { useForm } from "react-hook-form";

import { editProject } from "services";
import { useSnackbar } from "providers/SnackbarProvider";
import { useConfirmDialogExit } from "hooks";
import { Project } from "interfaces";
import {
  SingleStepBody,
  SingleStepDialog,
  SingleStepFooter,
  SingleStepHeaders,
} from "components/SingleStepDialog";
import {
  buttonSaveUpdate,
  formEditProject,
  modalEditProjectSubTitle,
  modalEditProjectTitle,
  snackbarSummarySuccessEditProject,
  snackbarSummarySuccessEditProjectSubTitle,
} from "_constants";
import { FormAddProject } from "components/form/FormAddProject";
import { useAppDispatch } from "store/store";
import { updateProjectName } from "store/slicer/GestioneProjectsSlice";

export const ModalRenameProject = ({
  project,
  showDialog = false,
  onClose,
}: {
  project: Project;
  showDialog: boolean;
  onClose: Function;
}) => {
  const dispatch = useAppDispatch();
  const [visible, setVisible] = useState(showDialog);
  const { showSnackbar } = useSnackbar();
  const { showConfirmDialogExit } = useConfirmDialogExit();

  const { handleSubmit, control, trigger } = useForm({
    defaultValues: {
      id: project.id,
      name: project.name,
    },
    shouldFocusError: false,
    mode: "onChange",
  });
  const onSubmit = (formData: any) => {
    editProject(formData)
      .then((_) => {
        showSnackbar({
          severity: "success",
          summary: snackbarSummarySuccessEditProject,
          detail: snackbarSummarySuccessEditProjectSubTitle,
          life: 5000,
        });
        dispatch(
          updateProjectName({
            id: formData.id,
            name: formData.name,
          } as any)
        );
        resetFormState();
      })
      .catch((_) => {});
  };
  const handleDismiss = () => {
    if (control._getDirty()) {
      showConfirmDialogExit({ rejectCallback: resetFormState });
    } else {
      resetFormState();
    }
  };

  const resetFormState = () => {
    control._reset();
    setVisible(false);
    onClose();
  };

  const stopPropagation = (e: any) => {
    e.stopPropagation();
  };

  return (
    <div onClick={(e) => stopPropagation(e)}>
      <SingleStepDialog
        onHideCallback={handleDismiss}
        height="auto"
        width="700px"
        header={
          <SingleStepHeaders
            title={modalEditProjectTitle}
            subtitle={modalEditProjectSubTitle}
          />
        }
        body={
          <SingleStepBody
            content={
              <form
                id={formEditProject}
                onSubmit={handleSubmit(onSubmit)}
                className="width-100"
              >
                <FormAddProject control={control} trigger={trigger} />
              </form>
            }
          />
        }
        footer={
          <SingleStepFooter
            dismiss={handleDismiss}
            form={formEditProject}
            labelSubmit={buttonSaveUpdate}
          />
        }
        display={visible}
        setVisible={setVisible}
      />
    </div>
  );
};
